











// vendor
import { defineComponent, computed, ref, PropType, set } from "@vue/composition-api";
// project
import * as AppModal from "@/AppModal";
import { ContextOption } from "@/components.generic/context-menu";
import { capitalize } from "@/utils/text";
// local
import { FormItem } from "../ts/types";

export default defineComponent({

	emits:[],
	props:{
		data:{
			type:Object as PropType<FormItem<any>>,
			required:true,
		}
	},
	components:{
	},
	setup(props){
		
		const label = computed(() => {

			

			const useAll = (props.data.platforms || []).length === 0;

			if(useAll){ return "Platform: All"; }

			const t = (props.data.platforms || []).map(pn => capitalize(pn)).join(", ");
			return `Platform: ${t}`;
		});


		const includesPlatform = (name:string) => {
			return props.data.platforms && props.data.platforms.includes(name);
		};
		

		const toggleOption = (name:string) => {

			const platforms = props.data.platforms || [];

			let i = platforms.indexOf(name);

			if(i >= 0){ return; }
			


			set(props.data, "platforms", [ name ]);
			
		};

		const toggleAll = () => {
			if(!props.data.platforms){ return; }
			set(props.data, "platforms", []);
		};

		const open = (e:Event) => {

			const useAll = (props.data.platforms || []).length === 0;
		
			const options:ContextOption[] = [
				{
					name:"All",
					icon: useAll ? "mdi.check" : undefined,
					order:-1,
					fn:toggleAll
				}
			];

			[ "desktop", "mobile"]
			.forEach(pn => {
				options.push({
					name:capitalize(pn),
					icon: includesPlatform(pn) ? "mdi.check" : undefined,
					fn:() => toggleOption(pn),
				})
			});

			AppModal.context(e, options);

		};

		return {
			label,
			open,
		};
	}
});

